import React, { Fragment } from 'react';

import Navbar from '../components/header/Navbar';
import About from '../components/About';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';

const ServicePage = () => {
    return (
        <Fragment>
            <Navbar />
            <About />
            <ContactUs />
            <Footer />
        </Fragment>
    );
}

export default ServicePage;
